export const rolesRoutes = [
  {id:1, role_name: "General Manager", route: "/location"  , label:"General Manager"},
  {id:2, role_name: "Manager", route: "/plant" , label:" Manager" },
  {id:3, role_name: "User", route: "/" , label:"User" },
];
